import { useLoyalty, useMembership } from '~/techstyle-shared/react-accounts';

const useRewardsTimeRemaining = () => {
  function getMonthDiff(start, end) {
    return (
      end.getMonth() -
      start.getMonth() +
      12 * (end.getFullYear() - start.getFullYear())
    );
  }

  function getAbbreviation(dateAbbreviation, isSingular = false) {
    if (dateAbbreviation === 'week') {
      if (isSingular) {
        return {
          id: 'site_account_vip.reward_week_remaining',
          defaultMessage: 'Week',
        };
      } else {
        return {
          id: 'site_account_vip.reward_weeks_remaining',
          defaultMessage: 'Week(s)',
        };
      }
    } else if (dateAbbreviation === 'month') {
      if (isSingular) {
        return {
          id: 'site_account_vip.reward_month_remaining',
          defaultMessage: 'Month',
        };
      } else {
        return {
          id: 'site_account_vip.reward_months_remaining',
          defaultMessage: 'Month(s)',
        };
      }
    } else {
      if (isSingular) {
        return {
          id: 'site_account_vip.reward_days_remaining',
          defaultMessage: 'Day',
        };
      } else {
        return {
          id: 'site_account_vip.reward_days_remaining',
          defaultMessage: 'Day(s)',
        };
      }
    }
  }

  function getWeekDiff(start, end) {
    const msInWeek = 7 * 24 * 60 * 60 * 1000;
    return Math.round(Math.abs(end - start) / msInWeek);
  }

  function getDaysDiff(startDate, endDate) {
    const msInDay = 24 * 60 * 60 * 1000;
    return Math.round(Math.abs(endDate - startDate) / msInDay);
  }

  function getCurrentDateTimeRemaining(startDate, endDate) {
    const days = getDaysDiff(startDate, endDate);
    const week = getWeekDiff(startDate, endDate);
    const month = getMonthDiff(startDate, endDate);

    let dateTimeRemaining = 0;
    let dateAbbreviation = getAbbreviation('day', true);
    let dateType = 'day';

    if (month > 0 || (days <= 30 && days >= 1)) {
      if ((month === 1 && days <= 30) || days <= 30 || days === 0) {
        dateTimeRemaining = days;
        dateAbbreviation = getAbbreviation('day', days === 1 || days === 0);
        dateType = 'day';
      } else if ((week >= 9 && week <= 11) || (week >= 5 && week <= 7)) {
        dateTimeRemaining = week;
        dateAbbreviation = getAbbreviation('week');
        dateType = 'week';
      } else if (month <= 4) {
        if (month === 4 || (month === 2 && week === 4 && days === 31)) {
          dateTimeRemaining = month - 1;
        } else if (
          (month === 2 && (week === 13 || week === 12)) ||
          (month === 1 && week === 8)
        ) {
          dateTimeRemaining = month + 1;
        } else {
          dateTimeRemaining = month;
        }
        dateAbbreviation = getAbbreviation(
          'month',
          month === 1 && week === 4 && days === 31
        );
        dateType = 'month';
      }
    }

    return {
      dateTimeRemaining: dateTimeRemaining,
      dateAbbreviation: dateAbbreviation,
      dateType: dateType,
    };
  }

  const getCurrentCountDownProgression = (today, start, end) => {
    const progress = Math.round(((today - start) / (end - start)) * 100);
    return progress <= 100 ? progress : 0;
  };

  const { tier } = useLoyalty();
  const membership = useMembership();
  const convertedDate = tier?.datetime_activated
    ? tier?.datetime_activated
    : membership?.dateActivated;
  const startDate = new Date(convertedDate);
  const getCurrentDate = new Date();
  const endDate = new Date(tier?.tierPromotionDate);

  return {
    results: getCurrentDateTimeRemaining(getCurrentDate, endDate),
    progress: getCurrentCountDownProgression(
      getCurrentDate,
      startDate,
      endDate
    ),
  };
};
export default useRewardsTimeRemaining;
